import { DateInput, DateInputProps, DateRangePicker, DateRangePickerChangeEvent, SelectionRange } from "@progress/kendo-react-dateinputs";
import { GridFilterCellProps } from "@progress/kendo-react-grid";
import { useState } from "react";


const cdi = (props: DateInputProps) => {
    return <label>
        <DateInput {...props} label={undefined} />
    </label>
}

export const DateRangeFilter = (props: GridFilterCellProps) => {
    const onValueChange = (event: DateRangePickerChangeEvent) => {
        setValue(event.value);
        if (event.value.start === null || event.value.end === null) {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event as any,
            });
        } else {
            props.onChange({
                value: [event.value.start, event.value.end],
                operator: "dateRange",
                syntheticEvent: event as any,
            });
        }
    };
    const [value, setValue] = useState(undefined as SelectionRange | undefined);
    return (
        <div className="k-filtercell">
            <DateRangePicker
                value={value}
                onChange={onValueChange}
                startDateInput={cdi}
                endDateInput={cdi}
            />
        </div>
    );
};